/**
 * Amostra Wigow - Add to Cart and Redirect to Checkout
 * Intercepts product links on amostra-wigow page and adds product to cart instead
 */

(function() {
  'use strict';

  // Check if we're on the amostra-wigow page
  const isAmostraWigowPage = () => {
    return window.location.pathname.includes('amostra-wigow') || 
           window.location.pathname.includes('amostras-wigow') ||
           window.location.pathname.includes('ebook-wigow') ||
           document.body.classList.contains('template-page') && 
           document.querySelector('[data-page-handle*="amostra"]');
  };

  // Product ID and handle
  const TARGET_PRODUCT_ID = '9253100945654';
  const TARGET_PRODUCT_HANDLE = 'kit-amostra-27g';
  const TARGET_VARIANT_ID = '49850451722486'; // First variant ID from the product data

  // Get first variant ID of the product
  const getFirstVariantId = async () => {
    // First, try using the known variant ID directly
    if (TARGET_VARIANT_ID) {
      return TARGET_VARIANT_ID;
    }
    
    try {
      // Fallback: Try to fetch by handle (more reliable than ID)
      const response = await fetch(`/products/${TARGET_PRODUCT_HANDLE}.js`);
      if (response.ok) {
        const product = await response.json();
        if (product.variants && product.variants.length > 0) {
          return product.variants[0].id.toString();
        }
      }
      
      // If handle doesn't work, try fetching all products and find by ID
      let page = 1;
      const limit = 250;
      
      while (page <= 10) {
        const response = await fetch(`/products.json?limit=${limit}&page=${page}`);
        if (!response.ok) {
          break;
        }
        
        const data = await response.json();
        if (!data.products) {
          break;
        }
        
        const product = data.products.find(p => p.id.toString() === TARGET_PRODUCT_ID.toString());
        
        if (product) {
          if (product.variants && product.variants.length > 0) {
            return product.variants[0].id.toString();
          }
          break;
        }
        
        if (data.products.length < limit) {
          break;
        }
        
        page++;
      }
      
      return null;
    } catch (error) {
      return null;
    }
  };

  // Add product to cart and redirect to checkout
  const addToCartAndCheckout = async (variantId) => {
    if (!variantId) {
      alert('Erro: Produto não encontrado. Por favor, tente novamente.');
      return;
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || 'Failed to add to cart');
      }

      const data = await response.json();
      
      // Redirect to checkout
      window.location.href = '/checkout';
    } catch (error) {
      alert('Erro ao adicionar produto ao carrinho. Por favor, tente novamente.');
    }
  };

  // Handle link clicks
  const handleLinkClick = async (e) => {
    const link = e.currentTarget;
    const href = link.getAttribute('href');
    
    // Check if link points to a product page
    if (href && (href.includes('/products/') || href.includes('shopify://products/'))) {
      e.preventDefault();
      e.stopPropagation();
      
      // Show loading state
      const originalText = link.textContent;
      if (link.tagName === 'A') {
        link.style.pointerEvents = 'none';
        link.style.opacity = '0.6';
        if (link.querySelector('.button')) {
          link.querySelector('.button').textContent = 'Adicionando...';
        } else {
          link.textContent = 'Adicionando...';
        }
      } else if (link.tagName === 'BUTTON') {
        link.disabled = true;
        link.textContent = 'Adicionando...';
      }
      
      // Get first variant and add to cart
      const variantId = await getFirstVariantId();
      await addToCartAndCheckout(variantId);
      
      // Restore original state if redirect fails
      if (link.tagName === 'A') {
        link.style.pointerEvents = '';
        link.style.opacity = '1';
        if (link.querySelector('.button')) {
          link.querySelector('.button').textContent = originalText;
        } else {
          link.textContent = originalText;
        }
      } else if (link.tagName === 'BUTTON') {
        link.disabled = false;
        link.textContent = originalText;
      }
    }
  };

  // Initialize
  const init = () => {
    if (!isAmostraWigowPage()) {
      return;
    }

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupListeners);
    } else {
      setupListeners();
    }
  };

  // Setup event listeners
  const setupListeners = () => {
    // Find all links and buttons that point to products
    const productLinks = document.querySelectorAll('a[href*="/products/"], a[href*="shopify://products/"], button[data-product-url*="/products/"]');
    
    productLinks.forEach(link => {
      link.addEventListener('click', handleLinkClick);
    });

    // Also handle dynamically added links (e.g., from sections)
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            // Check if the added node is a product link
            if (node.tagName === 'A' && (node.href.includes('/products/') || node.href.includes('shopify://products/'))) {
              node.addEventListener('click', handleLinkClick);
            }
            // Check for product links inside the added node
            const links = node.querySelectorAll && node.querySelectorAll('a[href*="/products/"], a[href*="shopify://products/"]');
            if (links) {
              links.forEach(link => {
                link.addEventListener('click', handleLinkClick);
              });
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  // Start
  init();
})();
